import { useEffect } from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { MessagesPanel } from '../messaging/MessagesPanel';

/** Guardian → Messages. Read-only from the guardian's perspective (they can
 *  reply but they can't start new threads — schools reach out first). */
export function GuardianMessagesPage() {
  return <MessagesPanel title="School messages" compact />;
}

/**
 * Deep-link resolver: SMS templates (I-10) link to
 * `/parent/messages/:thread`. MessagesPanel reads `?thread=<id>` from the
 * query, so we inject the param and render the same panel.
 */
export function GuardianMessageThreadPage() {
  const { thread = '' } = useParams<{ thread: string }>();
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    if (!thread) return;
    if (params.get('thread') === thread) return;
    const next = new URLSearchParams(params);
    next.set('thread', thread);
    setParams(next, { replace: true });
  }, [thread, params, setParams]);
  if (!thread) return <Navigate to="../" replace />;
  return <MessagesPanel title="School messages" compact />;
}
